import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

export default function AirportSelector({
  airports = [],
  value = "",
  onSelect,
}) {
  const [open, setOpen] = useState(false);

  const selected = airports.find(
    (a) => a.code === value
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          className="w-full justify-between"
        >
          {selected
            ? `${selected.code} - ${selected.name}`
            : "Search airport..."}

          <ChevronsUpDown className="ml-2 h-4 w-4 opacity-50" />
        </Button>
      </PopoverTrigger>

      <PopoverContent className="w-[500px] p-0">
        <Command>
          <CommandInput placeholder="Search airport..." />

          <CommandList>
            <CommandEmpty>
              Airport not found
            </CommandEmpty>

            <CommandGroup>
              {airports.map((airport) => (
                <CommandItem
                  key={airport.code}
                  value={`${airport.code} ${airport.name} ${airport.city}`}
                  onSelect={() => {
                    onSelect(airport);
                    setOpen(false);
                  }}
                >
                  <Check
                    className={`mr-2 h-4 w-4 ${
                      value === airport.code
                        ? "opacity-100"
                        : "opacity-0"
                    }`}
                  />

                  <div>
                    <div className="font-medium">
                      {airport.code} - {airport.name}
                    </div>

                    <div className="text-xs text-muted-foreground">
                      {airport.city}
                    </div>
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
